import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class GoogleSheetField extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [GoogleSheetField.enabled_attribute_name]: null,
      [GoogleSheetField.id_attribute_name]: null,
      [GoogleSheetField.name_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getEnabledAttributeName() {
    return this.enabled_attribute_name;
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  getId() {
    return this.getAttribute(GoogleSheetField.getIdAttributeName());
  }
}
_defineProperty(GoogleSheetField, "ORDER_ID", 'order_id');
_defineProperty(GoogleSheetField, "ORDER_DATE", 'order_date');
_defineProperty(GoogleSheetField, "CUSTOMER_NAME", 'customer_name');
_defineProperty(GoogleSheetField, "PHONE_NUMBER", 'phone_number');
_defineProperty(GoogleSheetField, "SHIPPING_ADDRESS", 'shipping_address');
_defineProperty(GoogleSheetField, "CUSTOMER_COUNTRY", 'customer_country');
_defineProperty(GoogleSheetField, "CUSTOMER_COUNTRY_CODE", 'customer_country_code');
_defineProperty(GoogleSheetField, "CITY", 'city');
_defineProperty(GoogleSheetField, "CUSTOM_CITY", 'custom_city');
_defineProperty(GoogleSheetField, "REGION", 'region');
_defineProperty(GoogleSheetField, "CUSTOM_REGION", 'custom_region');
_defineProperty(GoogleSheetField, "POSTAL_CODE", 'postal_code');
_defineProperty(GoogleSheetField, "PRODUCT_NAME", 'product_name');
_defineProperty(GoogleSheetField, "OFFER_NAME", 'offer_name');
_defineProperty(GoogleSheetField, "PRODUCT_SKU", 'product_sku');
_defineProperty(GoogleSheetField, "QUANTITY", 'quantity');
_defineProperty(GoogleSheetField, "TOTAL_PRICE", 'total_price');
_defineProperty(GoogleSheetField, "CURRENCY", 'currency');
_defineProperty(GoogleSheetField, "PAYMENT_METHOD", 'payment_method');
_defineProperty(GoogleSheetField, "UNIT_PRICE", 'unit_price');
_defineProperty(GoogleSheetField, "enabled_attribute_name", 'enabled');
_defineProperty(GoogleSheetField, "id_attribute_name", 'id');
_defineProperty(GoogleSheetField, "name_attribute_name", 'name');